<section id="project1" class="projects" data-scroll-nav="0">
	<div class="container-fluid">
		<div class="row">
			<div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="row">
					<div class="col-xl-7 col-md-7 col-sm-6" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
						<div class="d-flex flex-column justify-content-center h-100 service-content">
							<div>
								<h1 class="heading">VENDETTA</h1>
								<div class="points">
									<p>Vendetta Auto Garage Company exemplifies the seamless integration of tradition and innovation in the automotive industry.</p>
									<p> <a class="text-decoration-underline" href="https://vendettagarages.com/" target="_blank">vendettagarages.com</a>
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-5 col-md-5 col-sm-6">
						<div class="d-flex flex-column justify-content-center align-items-sm-end">
							<div class="list-block">
								<h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100"><a
										href="{{Url}}/project-details/vendetta#branding">Branding</a></h3>
								<h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="150"><a
										href="{{Url}}/project-details/vendetta#ui-ux">UI/UX Design</a></h3>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section data-scroll-nav="1" class="pb-0">
	<div class="container-fluid p-0">
		<div class="row">
			<div class="col-md-12 p-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
				<img src="{{baseUrl}}/images/projects/vendetta/vendetta-banner-min.png" alt="Branding and web development agency" width="" height="" loading="lazy">
			</div>
		</div>
	</div>
</section>
<section class="section bg-beyou about" data-scroll-nav="2">
	<div class="container">
		<div class="row">
			<div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-md-0 mx-sm-auto mx-auto" data-aos="fade-up"
				data-aos-duration="2000" data-aos-delay="100">
				<div class="content">
					<p class="mb-0">Pixtar was entrusted with translating our passion for precision car painting into a captivating digital platform. We relied on Pixtar to not only capture the essence of our expertise but also to craft a seamless and engaging website that reflects our commitment to automotive excellence.</p>
				</div>				
			</div>
		</div>
	</div>
</section>
<section class="bg-beyou branding pb-0" id="branding" data-scroll-nav="3">
  <div class="container">
    <div class="row">
      <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-11 col-11 mx-md-0 mx-sm-auto mx-auto" data-aos="fade-up" data-aos-duration="2000"
        data-aos-delay="100">
        <div class="content">
          <h1 class="heading mb-0">Branding</h1>
          <p>Pixtar undertook comprehensive branding work for Vendetta, starting with the creation of a distinctive logo that encapsulated the company's identity. Additionally, Pixtar designed eye-catching flyers, standees, and business cards that effectively conveyed 
						Vendetta's professionalism and expertise in car painting services.</p>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="bg-beyou branding" id="branding1">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12 p-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
				<div class="imglist mb-3">
					<img src="{{baseUrl}}/images/projects/vendetta/vendetta-branding-min.png" alt="Design and web development agency" width="" height="" loading="lazy">
				</div>
			</div>
			<div class="col-xxl-10 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="row">
					<div class="col-xl-6 col-lg-6 col-md-6 mx-lg-auto ps-md-0" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<img src="{{baseUrl}}/images/projects/vendetta/vendetta-left-min.png" alt="web designing agency" width="" height="" loading="lazy">
					</div>
					<div class="col-xl-6 col-lg-6 col-md-6 ps-md-0" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<div class="list">
							<img src="{{baseUrl}}/images/projects/vendetta/vendetta-right-min.png" alt="Brand agency" width="" height="" loading="lazy">
							<!-- <img src="{{baseUrl}}/images/projects/beyou/pack.jpg" alt="rebranding agency dubai" width="" height=""> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="bg-beyou typography" data-scroll-nav="5">
	<div class="container-fluid">
		<div class="row">
			<div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="typography" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
					<img src="{{baseUrl}}/images/projects/vendetta/typography.png" alt="best web design company in dubai" width="" height="" loading="lazy">
          <!-- <p data-aos="fade-up" data-aos-duration="2500" data-aos-delay="100">Through cohesive branding efforts, Pixtar helped Autokoorosh strengthen its brand presence, 
            establish credibility in the market, and attract new customers. The synergy between web development and branding ensured a holistic approach to enhancing Autokoorosh's 
            overall marketing strategy and driving business growth.</p> -->
				</div>
			</div>
		</div>
	</div>
</section>
<section class="section ui-ux" id="ui-ux" data-scroll-nav="8">
	<div class="container-fluid">
		<div class="row">
			<div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="row mb-4">
					<div class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<div class="content">
							<h1 class="heading mb-2">UI/UX Design</h1>
							<p class="">Pixtar developed a dynamic and user-friendly website for Vendetta Auto Garage Company. The website showcased Vendetta's
								services, including interior and exterior painting for all types of cars, with detailed descriptions and high-quality images. 
								Integration of interactive features allowed customers to easily request quotes and schedule appointments.</p>
						</div>
					</div>
				</div>
				<!-- <div class="row">
					<div class="col-lg-9 mx-lg-auto" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
						<video class="w-100 h-auto desktopimg" id="myVideo3" width="320" height="176" autoplay="true" muted="muted"
							loop="true" oncanplay="this.play()" onloadedmetadata="this.muted = true">
							<source src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh-desktop.mp4" type="video/mp4">
							<source src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh-desktop.ogg" type="video/ogg">
							Your browser does not support HTML5 video.
						</video>
						<video class="w-100 h-auto" id="myVideo3" width="320" height="176" autoplay="true" muted="muted" loop="true"
							oncanplay="this.play()" onloadedmetadata="this.muted = true">
							<source src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh_laptop.mp4" type="video/mp4">
							<source src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh_laptop.ogg" type="video/ogg">
							Your browser does not support HTML5 video.
						</video>
					</div>
				</div> -->
			</div>
		</div>
	</div>
</section>
<section class="technical" id="technical" data-scroll-nav="8">
	<div class="container">
		<div class="row">
			<div class="col-xxl-10 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-md-0 mx-sm-auto mx-auto">
				<div class="row mb-4">
					<div class="col-xxl-10 col-xl-12 col-lg-12 col-md-12 col-sm-12" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<div class="content">
							<p class="mb-md-4 -sm-3 mb-2">Pixtar's collaboration with Vendetta Auto Garage Company resulted in a successful digital transformation. The website
								and branding materials not only enhanced Vendetta's online presence but also positioned them as a leader in car painting services. Through 
								strategic web development and branding, Pixtar helped Vendetta attract new customers and drive business growth in the competitive automotive 
								market.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="next bg-black pb-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="next-block">
					<div class="in-line">
            <!-- {{Url}}/project-details/autokoorosh -->
						<a href="{{Url}}/project-details/spacex" class="text-white font-bold">
							<img src="{{baseUrl}}/images/projects/spacex/spacex-left.png" alt="Top branding agency in Dubai" width="280"
								height="280" loading="lazy">
							<h1 class="heading text-white">NEXT
								PROJECT</h1>
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="line"></div>
	</div>
</section>